import React, { useState } from 'react';
import {
  Box,
  Icon,
  MenuItem,
  TextField,
  Typography,
  InputAdornment
} from '@material-ui/core';


const SearchPatientField = ({ onSearch, isCustomer3 }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState('name');

  const handleSearchFieldChange = (event) => {
    const {value} = event.target;
    setSearchField(value);

    if (searchValue) {
      onSearch(searchValue, value);
    }
  };

  const handleSearchValueChange = (event) => {
    const {value} = event.target;
    setSearchValue(value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch(searchValue, searchField);
    }
  };

  const handleSearch = () => {
    onSearch(searchValue, searchField);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    onSearch('', 'name');
  };

  return (
    <Box className="my-8">
      <Typography variant="h6" gutterBottom>
        Search
      </Typography>
      <form>
        <div className="w-full flex items-center">
          <TextField
            select
            variant="outlined"
            className="w-full max-w-200 mr-3 text-primary"
            name="search-field"
            value={searchField}
            onChange={handleSearchFieldChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">by</InputAdornment>
              )
            }}
          >
            <MenuItem value="name">Name</MenuItem>
            <MenuItem value="email">Email</MenuItem>
            {isCustomer3 &&
              <MenuItem value="practice_name">Company/Practice Name</MenuItem>
            }
            <MenuItem value="phone_number">Phone</MenuItem>
          </TextField>
          <TextField
            variant="outlined"
            className="w-full text-primary"
            name="search-value"
            placeholder="Search"
            value={searchValue}
            onChange={handleSearchValueChange}
            onKeyPress={handleKeyPress}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon
                    color="primary"
                    onClick={handleSearch}
                  >
                    search
                  </Icon>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 && (
                    <Icon
                      color="primary"
                      className="cursor-pointer"
                      onClick={handleClearSearch}
                    >
                      close
                    </Icon>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </div>
      </form>
    </Box>
  );
};

export default SearchPatientField;
